import { FormField, TextInput } from 'grommet';

export const PassportId = (): JSX.Element => {
  return (
    <FormField
      name="hpePassportId"
      htmlFor="passport-id"
      label="HPE Passport ID"
    >
      <TextInput
        id="passport-id"
        name="hpePassportId"
        placeholder="HPE Passport ID"
      />
    </FormField>
  );
};
